import { render, staticRenderFns } from "./componentForm.vue?vue&type=template&id=56f212f8&"
import script from "./componentForm.vue?vue&type=script&lang=js&"
export * from "./componentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports